import * as getters from "./settings.getters";
import * as actions from "./settings.actions";
import * as mutations from "./settings.mutations";

import poiSettingsDefaults from "@data/poiSettingsDefaults";
import routeSettingsDefaults from "@data/routeSettingsDefaults";
import gasConsumptionSettingsDefaults from "@data/gasConsumptionSettingsDefaults";

const state = {
    poiSettings: poiSettingsDefaults,
    poiSettingsChanged: [],
    queryPoiSettings: false,
    queryPoiSettingsChanged: [],
    routeSettings: routeSettingsDefaults,
    routeSettingsChanged: false,
    routeSettingsChanges: [],
    savedRouteSettingsChanges:[],
    savedRouteSettings: false,
    queryRouteSettings: false, // settings to load route with if they are set via URL
    queryRouteSettingsChanges: false,
    savedRouteTime: false,
    routeTrafficTime: {
        isNow: true
    },
    routeCorridorRadius: 1, // in km
    gasConsumptionSettings: gasConsumptionSettingsDefaults
}

export default {
    namespaced: false,
    state,
    getters,
    actions,
    mutations
}